/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import axios from "axios";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import Map from "../components/am4chartMap/am4chartMap";
import { ORMAS_STATISTICS } from "../utils";
import { logoutUser } from "../actions/AuthAction";

function Dashboard(props) {
  const [bigChartData, setbigChartData] = React.useState("data1");

  const [dataGraph1, setDataGraph1] = useState({ label: [], dataGraph: [] });
  const [dataGraph2, setDataGraph2] = useState({ label: [], dataGraph: [] });
  const [dataGraph3, setDataGraph3] = useState({ label: [], dataGraph: [] });
  const [dataGraph4, setDataGraph4] = useState({ label: [], dataGraph: [] });
  const [dataGraph5, setDataGraph5] = useState({ label: [], dataGraph: [] });
  const [dataGraph6, setDataGraph6] = useState({ label: [], dataGraph: [] });
  const [dataGraph7, setDataGraph7] = useState({ label: [], dataGraph: [] });
  const [dataGraph8, setDataGraph8] = useState({ label: [], dataGraph: [] });
  const [dataGraph9, setDataGraph9] = useState({ label: [], dataGraph: [] });
  const [penggunaSioEsa, setPenggunaSioEsa] = useState([]);
  const [notif, setNotif] = useState([]);
  const [rekapanData, setRekapanData] = useState([]);
  const [loading, setLoading] = useState(true);

  // State untuk map control
  const [selectedIndicator, setSelectedIndicator] = useState("total_ormas");
  const [selectedYear, setSelectedYear] = useState(2024);
  const [indicatorOptions, setIndicatorOptions] = useState([]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      // User data is set but not used in this component
    } else {
      logoutUser(props.history);
    }
  }, [props.history]);

  // Opsi tahun
  const yearOptions = [2023, 2024, 2025];

  // Fungsi untuk mengambil data ORMAS per kecamatan
  const fetchDataOrmas = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ORMAS_STATISTICS}kecamatan-jenis`);

      if (response.data.success) {
        const data = response.data.data;
        setRekapanData(data);

        // Generate data grafik untuk setiap tab
        const labels = data.map((item) => item.kecamatan);

        // Tab 1: Total ORMAS
        const totalOrmas = data.map((item) => item.total_ormas);
        setDataGraph1({ label: labels, dataGraph: totalOrmas });

        // Tab 2: Berbadan Hukum
        const berbadanHukum = data.map((item) => item.berbadan_hukum);
        setDataGraph2({ label: labels, dataGraph: berbadanHukum });

        // Tab 3: Tidak Berbadan Hukum
        const tidakBerbadanHukum = data.map(
          (item) => item.tidak_berbadan_hukum
        );
        setDataGraph3({ label: labels, dataGraph: tidakBerbadanHukum });

        // Tab 4: Yayasan
        const yayasan = data.map((item) => item.yayasan);
        setDataGraph4({ label: labels, dataGraph: yayasan });

        // Tab 5: Perkumpulan
        const perkumpulan = data.map((item) => item.perkumpulan);
        setDataGraph5({ label: labels, dataGraph: perkumpulan });

        // Tab 6: Forum
        const forum = data.map((item) => item.forum);
        setDataGraph6({ label: labels, dataGraph: forum });

        // Tab 7: Lembaga
        const lembaga = data.map((item) => item.lembaga);
        setDataGraph7({ label: labels, dataGraph: lembaga });

        // Tab 8: Lainnya
        const lainnya = data.map((item) => item.lainnya);
        setDataGraph8({ label: labels, dataGraph: lainnya });

        // Tab 9: Sudah Melapor
        const sudahMelapor = data.map((item) => item.sudah_melapor);
        setDataGraph9({ label: labels, dataGraph: sudahMelapor });

        // Set indicator options untuk peta
        setIndicatorOptions([
          { value: "total_ormas", label: "Total ORMAS" },
          { value: "berbadan_hukum", label: "Berbadan Hukum" },
          { value: "tidak_berbadan_hukum", label: "Tidak Berbadan Hukum" },
          { value: "yayasan", label: "Yayasan" },
          { value: "perkumpulan", label: "Perkumpulan" },
          { value: "forum", label: "Forum" },
          { value: "lembaga", label: "Lembaga" },
          { value: "lainnya", label: "Lainnya" },
          { value: "sudah_melapor", label: "Sudah Melapor" },
        ]);
      }
    } catch (error) {
      console.error("Error fetching data ORMAS:", error);
      // Fallback data
      const fallbackData = [
        {
          kecamatan: "Kecamatan Contoh",
          total_ormas: 25,
          berbadan_hukum: 15,
          tidak_berbadan_hukum: 10,
          yayasan: 8,
          perkumpulan: 6,
          forum: 4,
          lembaga: 3,
          lainnya: 4,
          sudah_melapor: 20,
        },
      ];
      setRekapanData(fallbackData);
      setDataGraph1({ label: ["Kecamatan Contoh"], dataGraph: [25] });
      setDataGraph2({ label: ["Kecamatan Contoh"], dataGraph: [15] });
      setDataGraph3({ label: ["Kecamatan Contoh"], dataGraph: [70] });
      setDataGraph4({ label: ["Kecamatan Contoh"], dataGraph: [10] });
      setDataGraph5({ label: ["Kecamatan Contoh"], dataGraph: [5] });
      setDataGraph6({ label: ["Kecamatan Contoh"], dataGraph: [10] });
      setDataGraph7({ label: ["Kecamatan Contoh"], dataGraph: [5] });
      setDataGraph8({ label: ["Kecamatan Contoh"], dataGraph: [5] });
      setDataGraph9({ label: ["Kecamatan Contoh"], dataGraph: [5] });
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk mengambil data ORMAS per desa untuk peta
  const fetchDataOrmasDesa = async () => {
    try {
      const response = await axios.get(`${ORMAS_STATISTICS}kecamatan-jenis`);
      if (response.data.success) {
        const desaData = response.data.data;
        const transformedData = desaData.map((desa) => {
          let status = "Baik";
          let statusColor = "#00f2c3";
          const total = desa.total_ormas || 0;
          const berbadanHukum = desa.berbadan_hukum || 0;
          const persentaseBerbadanHukum =
            total > 0 ? Math.round((berbadanHukum / total) * 100) : 0;

          if (persentaseBerbadanHukum < 40) {
            status = "Kritis";
            statusColor = "#fd5d93";
          } else if (persentaseBerbadanHukum < 50) {
            status = "Sedang";
            statusColor = "#ff8d72";
          } else if (persentaseBerbadanHukum < 60) {
            status = "Kurang";
            statusColor = "#ffc107";
          }

          return {
            desa: desa.kecamatan,
            kecamatan: desa.kecamatan,
            total_ormas: desa.total_ormas,
            berbadan_hukum: desa.berbadan_hukum,
            tidak_berbadan_hukum: desa.tidak_berbadan_hukum,
            persentase_berbadan_hukum: persentaseBerbadanHukum,
            status: status,
            statusColor: statusColor,
            updatedAt: new Date().toISOString().split("T")[0],
          };
        });
        const sortedData = transformedData
          .sort((a, b) => b.total_ormas - a.total_ormas)
          .slice(0, 10); // Limit to top 10
        setPenggunaSioEsa(sortedData);
      }
    } catch (error) {
      console.error("Error fetching data ORMAS desa:", error);
      setPenggunaSioEsa([]);
    }
  };

  // Fungsi untuk mengambil data notifikasi ORMAS
  const fetchNotifikasiOrmas = async () => {
    try {
      const response = await axios.get(
        `${ORMAS_STATISTICS}statistik/jenis-ormas`
      );
      if (response.data.success) {
        const data = response.data.data;

        const transformedData = data.map((item, index) => ({
          status: item.jenis_ormas,
          singk: `Jenis ${index + 1}`,
          createdAt: new Date().toISOString(),
          source_table: "ormas",
          nama_dinas: item.jenis_ormas,
          catatan: `Total: ${item.total} organisasi`,
        }));

        setNotif(transformedData);
      } else {
        setNotif([]);
      }
    } catch (error) {
      console.error("Error fetching notifikasi ORMAS:", error);
      // Fallback data untuk testing
      const fallbackData = [
        {
          status: "YAYASAN",
          singk: "Jenis 1",
          createdAt: new Date().toISOString(),
          source_table: "ormas",
          nama_dinas: "YAYASAN",
          catatan: "Total: 10 organisasi",
        },
        {
          status: "PERKUMPULAN",
          singk: "Jenis 2",
          createdAt: new Date().toISOString(),
          source_table: "ormas",
          nama_dinas: "PERKUMPULAN",
          catatan: "Total: 5 organisasi",
        },
        {
          status: "FORUM",
          singk: "Jenis 3",
          createdAt: new Date().toISOString(),
          source_table: "ormas",
          nama_dinas: "FORUM",
          catatan: "Total: 8 organisasi",
        },
        {
          status: "LEMBAGA",
          singk: "Jenis 4",
          createdAt: new Date().toISOString(),
          source_table: "ormas",
          nama_dinas: "LEMBAGA",
          catatan: "Total: 6 organisasi",
        },
        {
          status: "LAINNYA",
          singk: "Jenis 5",
          createdAt: new Date().toISOString(),
          source_table: "ormas",
          nama_dinas: "LAINNYA",
          catatan: "Total: 3 organisasi",
        },
      ];
      setNotif(fallbackData);
    }
  };

  useEffect(() => {
    fetchDataOrmas();
  }, []);

  useEffect(() => {
    // Ambil data ORMAS desa untuk tabel
    fetchDataOrmasDesa();
    // Ambil data notifikasi ORMAS
    fetchNotifikasiOrmas();
  }, []);

  const setBgChartData = (name) => {
    setbigChartData(name);
  };

  let chart1_2_options = {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      backgroundColor: "#f5f5f5",
      titleFontColor: "#333",
      bodyFontColor: "#666",
      bodySpacing: 4,
      xPadding: 12,
      mode: "nearest",
      intersect: 0,
      position: "nearest",
    },
    responsive: true,
    scales: {
      yAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.0)",
            zeroLineColor: "transparent",
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax:
              Math.max(
                ...rekapanData.map((item) =>
                  Math.max(
                    item.total_ormas,
                    item.berbadan_hukum,
                    item.tidak_berbadan_hukum,
                    item.sudah_melapor
                  )
                )
              ) + 2,
            padding: 20,
            fontColor: "#9a9a9a",
          },
        },
      ],
      xAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.1)",
            zeroLineColor: "transparent",
          },
          ticks: {
            padding: 20,
            fontColor: "#9a9a9a",
          },
        },
      ],
    },
  };

  let chartExample1 = {
    data1: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(220,53,69,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(220,53,69,0.0)");
      gradientStroke.addColorStop(0, "rgba(220,53,69,0)"); //red colors

      return {
        labels: dataGraph1.label,
        datasets: [
          {
            label: "Total ORMAS",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#dc3545",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#dc3545",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#dc3545",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph1.dataGraph,
          },
        ],
      };
    },
    data2: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(255,193,7,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(255,193,7,0.0)");
      gradientStroke.addColorStop(0, "rgba(255,193,7,0)"); //yellow colors

      return {
        labels: dataGraph2.label,
        datasets: [
          {
            label: "Berbadan Hukum",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#ffc107",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#ffc107",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#ffc107",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph2.dataGraph,
          },
        ],
      };
    },
    data3: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(40,167,69,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(40,167,69,0.0)");
      gradientStroke.addColorStop(0, "rgba(40,167,69,0)"); //green colors

      return {
        labels: dataGraph3.label,
        datasets: [
          {
            label: "Tidak Berbadan Hukum",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#28a745",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#28a745",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#28a745",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph3.dataGraph,
          },
        ],
      };
    },
    data4: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(23,162,184,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(23,162,184,0.0)");
      gradientStroke.addColorStop(0, "rgba(23,162,184,0)"); //cyan colors

      return {
        labels: dataGraph4.label,
        datasets: [
          {
            label: "Yayasan",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#17a2b8",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#17a2b8",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#17a2b8",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph4.dataGraph,
          },
        ],
      };
    },
    data5: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(220,53,69,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(220,53,69,0.0)");
      gradientStroke.addColorStop(0, "rgba(220,53,69,0)"); //red colors

      return {
        labels: dataGraph5.label,
        datasets: [
          {
            label: "Perkumpulan",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#dc3545",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#dc3545",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#dc3545",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph5.dataGraph,
          },
        ],
      };
    },
    data6: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(255,193,7,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(255,193,7,0.0)");
      gradientStroke.addColorStop(0, "rgba(255,193,7,0)"); //yellow colors

      return {
        labels: dataGraph6.label,
        datasets: [
          {
            label: "Forum",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#ffc107",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#ffc107",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#ffc107",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph6.dataGraph,
          },
        ],
      };
    },
    data7: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(102,16,242,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(102,16,242,0.0)");
      gradientStroke.addColorStop(0, "rgba(102,16,242,0)"); //purple colors

      return {
        labels: dataGraph7.label,
        datasets: [
          {
            label: "Lembaga",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#6610f2",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#6610f2",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#6610f2",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph7.dataGraph,
          },
        ],
      };
    },
    data8: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(253,126,20,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(253,126,20,0.0)");
      gradientStroke.addColorStop(0, "rgba(253,126,20,0)"); //orange colors

      return {
        labels: dataGraph8.label,
        datasets: [
          {
            label: "Lainnya",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#fd7e14",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#fd7e14",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#fd7e14",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph8.dataGraph,
          },
        ],
      };
    },
    data9: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(108,117,125,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(108,117,125,0.0)");
      gradientStroke.addColorStop(0, "rgba(108,117,125,0)"); //gray colors

      return {
        labels: dataGraph9.label,
        datasets: [
          {
            label: "Sudah Melapor",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#6c757d",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#6c757d",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#6c757d",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph9.dataGraph,
          },
        ],
      };
    },
    options: chart1_2_options,
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col xs="12">
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col className="text-left" sm="6">
                    <h5 className="card-category">Data ORMAS Per Kecamatan</h5>
                    <CardTitle tag="h2">Grafik Statistik ORMAS</CardTitle>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col sm="12">
                    <ButtonGroup
                      className="btn-group-toggle mb-3"
                      data-toggle="buttons"
                    >
                      <Button
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data1",
                        })}
                        color="danger"
                        id="0"
                        size="sm"
                        onClick={() => setBgChartData("data1")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Total ORMAS
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-alert-circle-exc" />
                        </span>
                      </Button>
                      <Button
                        color="warning"
                        id="1"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data2",
                        })}
                        onClick={() => setBgChartData("data2")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Berbadan Hukum
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-chart-pie-36" />
                        </span>
                      </Button>
                      <Button
                        color="success"
                        id="2"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data3",
                        })}
                        onClick={() => setBgChartData("data3")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Tidak Berbadan Hukum
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-chart-bar-32" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="3"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data4",
                        })}
                        onClick={() => setBgChartData("data4")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Yayasan
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-simple-remove" />
                        </span>
                      </Button>
                      <Button
                        color="danger"
                        id="4"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data5",
                        })}
                        onClick={() => setBgChartData("data5")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Perkumpulan
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-simple-remove" />
                        </span>
                      </Button>
                      <Button
                        color="warning"
                        id="5"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data6",
                        })}
                        onClick={() => setBgChartData("data6")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Forum
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-simple-remove" />
                        </span>
                      </Button>
                      <Button
                        color="secondary"
                        id="6"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data7",
                        })}
                        onClick={() => setBgChartData("data7")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Lembaga
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-simple-remove" />
                        </span>
                      </Button>
                      <Button
                        color="dark"
                        id="7"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data8",
                        })}
                        onClick={() => setBgChartData("data8")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Lainnya
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-simple-remove" />
                        </span>
                      </Button>
                      <Button
                        color="light"
                        id="8"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data9",
                        })}
                        onClick={() => setBgChartData("data9")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Sudah Melapor
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-simple-remove" />
                        </span>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <div className="chart-area">
                  {loading ? (
                    <div className="text-center py-5">
                      <i className="tim-icons icon-refresh-02 fa-spin fa-2x text-info"></i>
                      <p className="mt-2">Memuat data...</p>
                    </div>
                  ) : (
                    <Line
                      data={chartExample1[bigChartData]}
                      options={chart1_2_options}
                    />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="6" md="12">
            <Card className="card-tasks">
              <CardHeader>
                <h6 className="title d-inline">
                  Status Jenis ORMAS ({notif.length})
                </h6>
                <p className="card-category d-inline"> per jenis</p>
                <UncontrolledDropdown>
                  <DropdownToggle
                    caret
                    color="link"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i className="tim-icons icon-settings-gear-63" />
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                    <li className="nav-link">
                      <a href="#pablo" className="nav-item dropdown-item">
                        Setelah hari ini
                      </a>
                    </li>
                    <li className="nav-link">
                      <a href="#pablo" className="nav-item dropdown-item">
                        Dari kemarin
                      </a>
                    </li>
                    <li className="nav-link">
                      <a href="#pablo" className="nav-item dropdown-item">
                        Minggu lalu
                      </a>
                    </li>
                    <li className="nav-link">
                      <a href="#pablo" className="nav-item dropdown-item">
                        Bulan lalu
                      </a>
                    </li>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader>
              <CardBody>
                <div className="table-full-width table-responsive">
                  <Table>
                    <tbody>
                      {notif.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input defaultValue="" type="checkbox" />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p
                              className="title"
                              style={{ marginBottom: "0px" }}
                            >
                              {item.status}
                            </p>
                            <p className="text-muted">
                              {item.singk + " - " + formatDate(item.createdAt)}
                            </p>
                            <p>
                              {item.source_table === "ormas"
                                ? "Data ORMAS"
                                : item.nama_dinas || "Jenis ORMAS"}
                            </p>
                            <p className="text-muted">{item.catatan}</p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id={`tooltip${index}`}
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-chart-bar-32" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target={`tooltip${index}`}
                              placement="right"
                            >
                              Lihat Detail Jenis ORMAS
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6" md="12">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col md="6">
                    <CardTitle tag="h4">
                      Data Kecamatan ORMAS (10 Tertinggi)
                    </CardTitle>
                    <p className="card-category">Berdasarkan total ORMAS</p>
                  </Col>
                  <Col md="6">
                    <FormGroup className="mb-0">
                      <Label for="yearSelectTable" className="text-sm mb-1">
                        Tahun
                      </Label>
                      <Input
                        type="select"
                        id="yearSelectTable"
                        value={selectedYear}
                        onChange={(e) =>
                          setSelectedYear(parseInt(e.target.value))
                        }
                        size="sm"
                      >
                        {yearOptions.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Kecamatan</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Total</th>
                      <th className="text-center">Berbadan Hukum</th>
                      <th className="text-center">Tidak Berbadan Hukum</th>
                      <th className="text-center">Persentase Berbadan Hukum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {penggunaSioEsa &&
                      penggunaSioEsa.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{item.desa}</strong>
                          </td>
                          <td className="text-center">
                            <span
                              style={{
                                backgroundColor: item.statusColor,
                                color: "white",
                                padding: "4px 8px",
                                borderRadius: "12px",
                                fontSize: "11px",
                                fontWeight: "600",
                              }}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td className="text-center">
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#007bff",
                              }}
                            >
                              {item.total_ormas}
                            </span>
                          </td>
                          <td className="text-center">
                            <span style={{ fontWeight: "600" }}>
                              {item.berbadan_hukum}
                            </span>
                          </td>
                          <td className="text-center">
                            <span style={{ fontWeight: "600" }}>
                              {item.tidak_berbadan_hukum}
                            </span>
                          </td>
                          <td className="text-center">
                            <span
                              style={{
                                fontWeight: "600",
                                color:
                                  item.persentase_berbadan_hukum >= 60
                                    ? "#00f2c3"
                                    : item.persentase_berbadan_hukum >= 50
                                    ? "#ffc107"
                                    : item.persentase_berbadan_hukum >= 40
                                    ? "#ff8d72"
                                    : "#fd5d93",
                              }}
                            >
                              {item.persentase_berbadan_hukum}%
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
                <div
                  className="mt-3 p-3"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-muted">
                      Total Kecamatan: {penggunaSioEsa.length}
                    </span>
                    <span className="text-muted">
                      Total ORMAS:{" "}
                      {penggunaSioEsa.reduce(
                        (sum, item) => sum + (item.total_ormas || 0),
                        0
                      )}
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card
              className="card-tasks"
              style={{
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                border: "none",
                borderRadius: "12px",
                overflow: "hidden",
                marginBottom: "30px",
                minHeight: "750px",
              }}
            >
              <CardHeader
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  borderBottom: "none",
                  padding: "20px 25px",
                }}
              >
                <Row className="align-items-center">
                  <Col md="6">
                    <CardTitle tag="h4" className="mb-0 text-white">
                      <i className="tim-icons icon-chart-bar-32 mr-2"></i>
                      Peta Sebaran ORMAS Kabupaten Rote Ndao
                    </CardTitle>
                    <p
                      className="text-white-50 mb-0 mt-1"
                      style={{ fontSize: "14px" }}
                    >
                      Visualisasi data ORMAS per desa dengan berbagai indikator
                    </p>
                  </Col>
                  <Col md="6">
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-0">
                          <Label
                            for="indicatorSelect"
                            className="text-white text-sm mb-1"
                            style={{ fontWeight: "500" }}
                          >
                            <i className="tim-icons icon-bullet-list-67 mr-1"></i>
                            Indikator
                          </Label>
                          <Input
                            type="select"
                            id="indicatorSelect"
                            value={selectedIndicator}
                            onChange={(e) =>
                              setSelectedIndicator(e.target.value)
                            }
                            style={{
                              color: "black",
                              fontSize: "14px",
                              padding: "8px 12px",
                              height: "auto",
                              minHeight: "38px",
                            }}
                          >
                            {indicatorOptions.map((option, index) => (
                              <option
                                key={index}
                                value={option.value}
                                style={{
                                  color: "black",
                                  fontSize: "14px",
                                  padding: "8px",
                                }}
                              >
                                {option.label}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-0">
                          <Label
                            for="yearSelect"
                            className="text-white text-sm mb-1"
                            style={{ fontWeight: "500" }}
                          >
                            <i className="tim-icons icon-calendar-60 mr-1"></i>
                            Tahun
                          </Label>
                          <Input
                            type="select"
                            id="yearSelect"
                            value={selectedYear}
                            onChange={(e) =>
                              setSelectedYear(parseInt(e.target.value))
                            }
                            style={{
                              color: "black",
                              fontSize: "14px",
                              padding: "8px 12px",
                              height: "auto",
                              minHeight: "38px",
                            }}
                          >
                            {yearOptions.map((year, index) => (
                              <option
                                key={index}
                                value={year}
                                style={{
                                  color: "black",
                                  fontSize: "14px",
                                  padding: "8px",
                                }}
                              >
                                {year}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody
                className="p-0"
                style={{ position: "relative", height: "calc(100% - 120px)" }}
              >
                <div
                  style={{
                    position: "relative",
                    height: "100%",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    borderRadius: "0 0 12px 12px",
                    overflow: "visible",
                  }}
                >
                  <Map
                    selectedIndicator={selectedIndicator}
                    selectedYear={selectedYear}
                  />
                </div>
                {/* Info badge */}
                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    background: "rgba(255, 255, 255, 0.95)",
                    padding: "8px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    color: "#666",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    zIndex: 1001,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i className="tim-icons icon-info text-info mr-1"></i>
                  Hover pada desa untuk detail lengkap
                </div>
                {/* Total info badge */}
                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    left: "15px",
                    background: "rgba(0, 123, 255, 0.9)",
                    padding: "8px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    zIndex: 1001,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i className="tim-icons icon-chart-bar-32 mr-1"></i>
                  Total:{" "}
                  {rekapanData.reduce(
                    (sum, item) => sum + (item.total_ormas || 0),
                    0
                  )}{" "}
                  ORMAS
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
